import connectGetter from 'lib/common/utils/connectGetter';

const POLL_TRANSFER_COMPLETE_TRIES = 10;
const TIME_MS_BETWEEN_TRANSFER_POLL = 1000;

export default async function waitForContactEnded(contact: connect.Contact, retries = POLL_TRANSFER_COMPLETE_TRIES) {
  const contactType = connectGetter(contact, 'getState')?.type;

  // If no contact type it's because the contact no longer exists, let it be destroyed
  if (!contactType || contactType === connect.ContactStateType.ENDED) {
    return Promise.resolve();
  }

  if (contactType === connect.ContactStateType.ERROR || retries === 0) {
    return Promise.reject();
  }

  await new Promise((resolve) => setTimeout(resolve, TIME_MS_BETWEEN_TRANSFER_POLL));

  return waitForContactEnded(contact, retries - 1);
}
